import { createSelector } from 'reselect'
import { parseQuery } from '@calendly/http-tools'

import { eventTypeSelector } from 'root-api'
import { currentUserSelector } from 'selectors/user'
import { isEmbeddedSelector } from 'selectors/embed'

export const canRequestDiagnosticsSelector = createSelector(
  currentUserSelector,
  isEmbeddedSelector,
  eventTypeSelector,
  (user, embedded, eventType) => {
    if (!user || embedded) return false
    if (eventType && eventType.type === 'AdhocEventType') return false
    if (window.location.pathname.startsWith('/cancellations')) return false

    return true
  }
)

export const isDiagnosticsAvailableSelector = createSelector(
  eventTypeSelector,
  (eventType) => eventType?.policy?.diagnostics
)

export const isDiagnosticsEnabledSelector = createSelector(
  currentUserSelector,
  isDiagnosticsAvailableSelector,
  ({ current_user: user }) => !!user?.diagnostics?.enabled,
  (currentUser, available, enabled) => {
    if (!currentUser || !available) return false
    return enabled || parseQuery(window.location.search).diagnostics === '1'
  }
)
